import React, { useEffect } from "react";
import "./TeamModal.css";
import { useLanguage } from "../../LanguageContext";
import { staticUrl } from "../../config";

/*
 * Full profile for one board or management member.
 *
 * The card used to expand in place, inside a horizontal slider, which capped the
 * biography at a fixed height and clipped anything longer. Biographies can now
 * run to 5000 characters, so they get a dialog with room to hold one.
 */
function TeamModal({ member, onClose }) {
    const { language } = useLanguage();

    // Escape closes it, and the page behind must not scroll while it is open.
    useEffect(() => {
        const onKeyDown = (event) => {
            if (event.key === "Escape") onClose();
        };
        document.addEventListener("keydown", onKeyDown);

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.removeEventListener("keydown", onKeyDown);
            document.body.style.overflow = previousOverflow;
        };
    }, [onClose]);

    if (!member) return null;

    const dynamicStyles = {
        fontFamily: language === "ARM" && "Mardoto",
        fontWeight: language === "ARM" && 500,
    };

    return (
        <div className="team-modal-overlay" onClick={onClose}>
            <div
                className="team-modal"
                onClick={(e) => e.stopPropagation()}
                style={dynamicStyles}
                role="dialog"
                aria-modal="true"
                aria-label={member.name}
            >
                {/* Same close control as the ArcaPay modal, so the two dialogs match. */}
                <button className="team-modal-close" onClick={onClose} aria-label="Close">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="18" cy="18" r="18" fill="#E5E5E5" />
                        <path
                            d="M12 22.6753C12 23.4416 12.6986 24 13.6766 24C14.4217 24 14.8254 23.7662 15.3997 23.039L17.9457 19.8961H18.0543L20.5382 23.039C21.0815 23.7532 21.5006 24 22.2613 24C23.2704 24 23.969 23.4416 23.969 22.6494C23.969 22.2727 23.8292 21.961 23.4877 21.5714L20.2898 18L23.5032 14.4026C23.8448 14.013 24 13.7013 24 13.3247C24 12.5584 23.3014 12 22.3079 12C21.5472 12 21.1125 12.2468 20.6003 12.9481L18.1785 16.1039H18.0543L15.5395 12.9481C14.9806 12.2338 14.5614 12 13.8008 12C12.8072 12 12.0931 12.5714 12.0931 13.3506C12.0931 13.7532 12.2484 14.0519 12.6054 14.4675L15.7102 17.961L12.4812 21.6104C12.1397 22 12 22.2987 12 22.6753Z"
                            fill="#ABABAB"
                        />
                    </svg>
                </button>

                <div className="team-modal-body">
                    <div className="team-modal-photo">
                        <img src={staticUrl(member.image)} alt={member.name} />
                    </div>
                    <div className="team-modal-content">
                        <h2 style={dynamicStyles}>{member.name}</h2>
                        <p className="team-modal-role" style={dynamicStyles}>{member.position}</p>
                        <div className="team-modal-description">
                            <p style={dynamicStyles}>{member.description}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TeamModal;
